export function extractBlobPath(url: string): string {
	const urlObj = new URL(url);
	const pathWithoutContainer = urlObj.pathname.split("/").slice(2).join("/");
	return decodeURIComponent(pathWithoutContainer);
}
